module.exports = "/assets/44219b4d9eada7152fd482f32c8e3a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B8.png
// module id = 1221
// module chunks = 0